export default __webpack_public_path__ + "4532576faf27ae951523daab2563bd59.png";